import React from 'react';
import './ButtonGroup.scss';

interface IButtonsGroupProps {
  children?: React.ReactNode;
  column?: boolean;
  topSpace?: boolean;
}

export function ButtonGroup({ children, column, topSpace }: IButtonsGroupProps) {
  const CSS_BUTTON_GROUP = 'ButtonGroup';
  const CSS_COLUMN = 'column';
  const CSS_TOP_SPACE = 'top-space';
  const cssClass = `${CSS_BUTTON_GROUP}${column ? ' ' + CSS_COLUMN : ''} ${topSpace ? ' ' + CSS_TOP_SPACE : ''}`;
  return (
    <div className={cssClass}>
      { children }
    </div>
  );
}
